"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("./index");
function getUser(userId) {
    return index_1.Users$.getState()[userId];
}
exports.default = getUser;
//# sourceMappingURL=getUser.js.map